/**
 * @generated SignedSource<<aa88739130f4138c35a8cbd1dbb396a4>>
 * @relayHash 4c538c694c48bd55cf3ba170f6e7210c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2a29cf1d6127965d288b5e91813fb3607ff4f38a6781286ddae1de806a315062

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CapacityPageHeaderQuery } from './CapacityPageHeaderQuery.graphql';

const node: PreloadableConcreteRequest<CapacityPageHeaderQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2a29cf1d6127965d288b5e91813fb3607ff4f38a6781286ddae1de806a315062",
    "metadata": {},
    "name": "CapacityPageHeaderQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
